module.exports = __webpack_public_path__ + "static/fb-instagram-a2bb1cd1e269f2c28b40b4f81186633d.png";